import { render, staticRenderFns } from "./MetaLeadsChannels.vue?vue&type=template&id=f10e3ee2&scoped=true"
import script from "./MetaLeadsChannels.vue?vue&type=script&lang=js"
export * from "./MetaLeadsChannels.vue?vue&type=script&lang=js"
import style0 from "./MetaLeadsChannels.vue?vue&type=style&index=0&id=f10e3ee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10e3ee2",
  null
  
)

export default component.exports